namespace Gordic.Pod.Dlg
{
    const { gcontent } = Decorators

    @gcontent
    export class HromadnaOpravaMetadatOvereniDlg extends GContentBase<Gordic.Wfl.AC.WflBaseAC> 
    {
        model: Interface.GHromadnaOpravaMetadatOvereniDto[];

        onContentReady()
        {
            this.SetData();
            Gordic.Wfl.AC.WflBaseAC.InitControl(this);
            Gordic.Wfl.AC.WflBaseAC.CompleteMenu(this);
        }

        SetData()
        {
            const that = this;
            const form = new Gordic.Forms
                .Form({ name: "frmHromadnaOprava", layoutDescriptor: "L1M1S1" })
                .addSection().addRow({ label: "" }).addField("gradio", {
                    name: "Zpusob", itemClass: "",  //RC 26285666 : Typ převzetí
                    initialValue: Gordic.Pod.Interface.ZpusobOvereniHromadneAktualizaceMetadat.kDatuDodani,
                    radios: [
                        { value: Gordic.Pod.Interface.ZpusobOvereniHromadneAktualizaceMetadat.kDatuDodani, label: 'jres:23900178' }, //RC 23900178 : k datu dodání
                        { value: Gordic.Pod.Interface.ZpusobOvereniHromadneAktualizaceMetadat.kDatuStazeni, label: 'jres:23900179' }, //RC 23900179 : k datu stažení
                        { value: Gordic.Pod.Interface.ZpusobOvereniHromadneAktualizaceMetadat.keKonkretnimuDatu, label: 'jres:23900180' }, //RC 23900180 : ke konkrétnímu datu

                ],
                change: function (event, input) {
                    //if (input.value) {
                    //    if (that.defaultForm) {
                    //        that.defaultForm.findFields(fieldNames.referent).gfield("option", "disabled", input.value != 1);
                    //        that.defaultForm.findFields(fieldNames.extSubject).gfield("option", "disabled", input.value == 1);
                    //    }
                    //}
                }

                });
            form.addRow("jres:23900182") //RC 23900182 : K datu
                .addField("gdatebox", { name: "KDatu", disabled: false })

            form.addRow({ layoutDescriptor: "w-12" }).addField("gcheck", { name: "OveritKDatuTst", label: "jres:23900181" }) //RC 23900181 : Oveřit k datu časového razítka (pokud existuje)
            this.defaultForm = $("<div>").appendTo(this.element).gform("createFrom", form);
            this.findFields().gfield("model", "apply", this.model);
        }

        OKClick()
        {
            const that = this;
            this.findForms("frmHromadnaOprava").findFields().gfield("model", "collect", this.model);
            this.call("SaveSettings", { model: this.model })
                .done(function () {
                    that.close(that.model);    
                })  
        }
    }
}